import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useDispatch, useSelector} from 'react-redux';

import {selectUserAgent} from 'src/selectors/accounts';
import {validateEmail} from 'src/utils/index';
import {getReferrerPortalLink} from 'src/utils/referral-external';
import * as api from 'src/utils/redux-api-v2';

import {isMobile} from 'src/utils/responsive';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
} from '@spaced-out/ui-design-system/lib/components/index';


const TrackFormModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => unknown;
}) => {
  const {t} = useLabelTranslation();
  const dispatch = useDispatch();
  const userAgent = useSelector(selectUserAgent);

  const [email, setEmail] = React.useState('');

  const onChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const onSubmit = async () => {
    const response: 'agent' | 'other' = await dispatch(
      api.get(`referral/external/user/track-referral-url`, {
        email,
      }),
    );

    const trackingUrl =
      response === 'agent'
        ? '/referralv2/tracking/all-referrals'
        : `${getReferrerPortalLink()}?email=${encodeURIComponent(email ?? '')}`;

    window.open(trackingUrl, '_blank');
    setEmail('');
    onClose();
  };

  const onCancel = () => {
    setEmail('');
    onClose();
  };

  return (
    <Modal
      size={isMobile(userAgent) ? 'small' : 'medium'}
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalHeader onCloseButtonClick={onClose}>
        {t('Enter_Email_to_Proceed', 'Enter Email to Proceed')}
      </ModalHeader>
      <ModalBody>
        <Input
          label={t('Email', 'Email')}
          required={true}
          placeholder={t(
            'Email_ID_eg_nameexamplecom',
            'Email ID (e.g., name@example.com)',
          )}
          onChange={onChangeEmail}
          value={email}
        />
      </ModalBody>
      <ModalFooter>
        <Button onClick={onCancel} type="secondary">
          {t('Cancel', 'Cancel')}
        </Button>
        <Button disabled={!validateEmail(email)} onClick={onSubmit}>
          {t('Submit', 'Submit')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TrackFormModal;
